/* Minvelle Cart v2 */
(function () {
  'use strict';
  const FREE_SHIPPING_THRESHOLD_CENTS = 2900;
  const BELOW_THRESHOLD_RATE_CENTS = 399;
  const SUB_PLAN_ID = 692093845850;
  const VARIANT_1BOX = 53814535455066;
  const VARIANT_2BOX = 53814535487834;
  const VARIANT_6BOX = 53814535520602;

  const t = (k) => fxStr((window.MinvelleCartStrings || {})[k] || k);
  // ponytail: format in the cart's real presentment currency (US visitors get USD, not a hardcoded €)
  let _moneyFmt = null, _cartCurrency = '';
  function setCurrency(cur){
    cur = cur || 'EUR';
    if (_moneyFmt && cur === _cartCurrency) return;
    _cartCurrency = cur;
    const lang = (document.documentElement.lang || 'en').slice(0, 2);
    try { _moneyFmt = new Intl.NumberFormat(lang === 'de' ? 'de-AT' : 'en-US', { style: 'currency', currency: cur }); }
    catch (e) { _moneyFmt = null; }
    if (cur !== 'EUR') document.documentElement.setAttribute('data-mv-currency', cur);
    else document.documentElement.removeAttribute('data-mv-currency');
  }
  const fmtMoney = (c) => _moneyFmt ? _moneyFmt.format(c / 100) : '€' + (c / 100).toFixed(2).replace('.', ',');

  // ponytail: EUR literals shown to non-EUR sessions get converted with the Markets FX rate; EUR sessions are untouched
  function fxRate(){
    const cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!cur || cur === 'EUR') return null;
    const fx = parseFloat(window.Shopify.currency.rate);
    if (!fx || !isFinite(fx)) return null;
    return { cur, fx };
  }
  function fmtFx(eurCents, r, opts){
    opts = opts || {};
    const lang = (document.documentElement.lang || 'en').slice(0, 2);
    const loc = opts.locale || (lang === 'de' ? 'de-AT' : 'en-US');
    const v = eurCents * r.fx / 100;
    try {
      if (opts.whole) return new Intl.NumberFormat(loc, { style: 'currency', currency: r.cur, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(v));
      return new Intl.NumberFormat(loc, { style: 'currency', currency: r.cur }).format(v);
    } catch (e) { return null; }
  }
  // Rewrites "€NN" / "€NN.NN" / "NN,NN €" tokens inside a localized string; whole-EUR amounts round to whole units.
  function fxStr(s){
    const r = fxRate();
    if (!r || typeof s !== 'string' || s.indexOf('\u20ac') === -1) return s;
    return s.replace(/\u20ac\s?(\d+(?:[.,]\d{2})?)|(\d+(?:[.,]\d{2})?)\s?\u20ac/g, (m, a, b) => {
      const num = a || b;
      const whole = !/[.,]/.test(num);
      const out = fmtFx(Math.round(parseFloat(num.replace(',', '.')) * 100), r, { whole });
      return out === null ? m : out;
    });
  }
  // Static markup tagged with data-mv-eur-cents gets rewritten in place for non-EUR sessions.
  function convertTagged(){
    const r = fxRate();
    if (!r) return;
    document.querySelectorAll('[data-mv-eur-cents]').forEach((el) => {
      const cents = parseInt(el.getAttribute('data-mv-eur-cents'), 10);
      if (!cents) return;
      const scope = el.closest('[lang]');
      const lang = scope ? (scope.getAttribute('lang') || '').slice(0, 2) : '';
      const out = fmtFx(cents, r, { locale: lang === 'de' ? 'de-AT' : (lang === 'en' ? 'en-US' : null) });
      if (out !== null) el.textContent = out;
    });
  }


  // ponytail: EUR shipping constants converted to cart currency via Shopify Markets FX rate; null = rate unknown, hide the bar instead of lying
  function shipConsts(cur){
    if (!cur || cur === 'EUR') return { threshold: FREE_SHIPPING_THRESHOLD_CENTS, cost: BELOW_THRESHOLD_RATE_CENTS };
    const fx = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if (!fx || !isFinite(fx)) return null;
    return { threshold: Math.round(FREE_SHIPPING_THRESHOLD_CENTS * fx), cost: Math.round(BELOW_THRESHOLD_RATE_CENTS * fx) };
  }

  const state = { cart: null, open: false };
  let elRoot, elBackdrop;

  // Device + browser detection for express-wallet filtering
  const _ua = navigator.userAgent;
  const _isIOS = /iPad|iPhone|iPod/.test(_ua) && !window.MSStream;
  const _isMac = /Macintosh/.test(_ua) && !_isIOS;
  const _isAndroid = /Android/.test(_ua);
  const _isSafari = /Safari/.test(_ua) && !/Chrome|Chromium|Edg/.test(_ua);
  const _isAppleDevice = _isIOS || _isMac;
  const _isChromeDesktop = /Chrome/.test(_ua) && !/Android|Mobile/.test(_ua);

  function filterWallets(){
    const root = document.querySelector('shopify-accelerated-checkout-cart');
    if (!root) return;
    const tagMap = [
      { match: 'apple-pay', key: 'apple' },
      { match: 'google-pay', key: 'google' },
      { match: 'paypal',    key: 'paypal' },
      { match: 'shop-pay',  key: 'shop'   }
    ];
    const hideKeys = new Set();
    if (_isIOS) {
      hideKeys.add('google'); hideKeys.add('paypal');
    } else if (_isAndroid) {
      hideKeys.add('apple'); hideKeys.add('paypal');
    } else if (_isMac && _isSafari) {
      hideKeys.add('google');
    } else if (_isChromeDesktop || (!_isAppleDevice && !_isAndroid)) {
      hideKeys.add('apple');
    }
    if (hideKeys.size === 0) return;
    const candidates = [];
    for (const c of Array.from(root.children)) {
      const tag = c.tagName.toLowerCase();
      const hit = tagMap.find((m) => tag.includes(m.match));
      if (!hit) continue;
      candidates.push({ el: c, key: hit.key });
    }
    // Safety net: never hide every wallet
    const remainingAfterHide = candidates.filter((c) => !hideKeys.has(c.key));
    if (candidates.length > 0 && remainingAfterHide.length === 0) return;
    for (const c of candidates) {
      if (hideKeys.has(c.key)) c.el.style.display = 'none';
    }
  }

  async function fetchCart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('cart-fetch-failed');return r.json();}
  async function addItem(vId,qty,plan){const body={id:vId,quantity:qty||1};if(plan)body.selling_plan=plan;const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok){const m=await r.text();throw new Error('add-failed:'+m.slice(0,200));}const item=await r.json();trackATC(item);return item;}

  // Klaviyo "Added to Cart" — fire-and-forget, never blocks the cart flow
  function trackATC(item){
    try {
      const k = (window.klaviyo = window.klaviyo || []);
      fetchCart().then((cart) => {
        k.push(['track', 'Added to Cart', {
          $value: cart.total_price / 100,
          AddedItemProductName: item.product_title,
          AddedItemProductID: item.product_id,
          AddedItemSKU: item.sku,
          AddedItemPrice: item.price / 100,
          AddedItemQuantity: item.quantity,
          AddedItemURL: window.location.origin + (item.url || ''),
          AddedItemImageURL: item.image || '',
          ItemNames: cart.items.map((i) => i.product_title),
          CheckoutURL: window.location.origin + '/checkout',
          Items: cart.items.map((i) => ({
            ProductID: i.product_id,
            SKU: i.sku,
            ProductName: i.product_title,
            Quantity: i.quantity,
            ItemPrice: i.price / 100,
            RowTotal: i.line_price / 100,
            ProductURL: window.location.origin + (i.url || ''),
            ImageURL: i.image || ''
          }))
        }]);
      }).catch(() => {});
    } catch (e) { /* tracking must never break add-to-cart */ }
  }
  async function changeLine(key,upd){const body=Object.assign({id:key},upd);const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});if(!r.ok)throw new Error('change-failed');return r.json();}
  async function applyDiscount(code){
    const r=await fetch('/discount/'+encodeURIComponent(code),{redirect:'manual'});
    return r;
  }

  function open(){if(!elRoot)return;state.open=true;elRoot.setAttribute('open','');elBackdrop.setAttribute('open','');document.body.style.overflow='hidden';document.dispatchEvent(new CustomEvent('minvelle:cart:open'));ensureExpressCheckout();}

  let _expressLoaded = false;
  let _expressLoading = null;
  async function ensureExpressCheckout(){
    const wrap = elRoot && elRoot.querySelector('[data-express-wallets]');
    const label = elRoot && elRoot.querySelector('[data-express-label]');
    if (!wrap) return;
    if (_expressLoaded) return;
    if (_expressLoading) return _expressLoading;
    _expressLoading = (async () => {
      try {
        const r = await fetch('/cart', { credentials: 'same-origin' });
        if (!r.ok) throw new Error('cart-fetch-' + r.status);
        const html = await r.text();
        const m = html.match(/<shopify-accelerated-checkout-cart[^>]*>[\s\S]*?<\/shopify-accelerated-checkout-cart>/);
        if (!m) throw new Error('component-not-found');
        wrap.innerHTML = m[0];
        if (label) label.hidden = false;
        if (label) label.removeAttribute('hidden');
        await new Promise(res => setTimeout(res, 50));
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
        _expressLoaded = true;
        setTimeout(filterWallets, 600);
        setTimeout(filterWallets, 1500);
      } catch (e) {
        console.warn('[MinvelleCart] express checkout load failed', e);
        if (label) label.hidden = true;
        wrap.innerHTML = '';
      } finally {
        _expressLoading = null;
      }
    })();
    return _expressLoading;
  }
  function close(){if(!elRoot)return;state.open=false;elRoot.removeAttribute('open');elBackdrop.removeAttribute('open');document.body.style.overflow='';document.dispatchEvent(new CustomEvent('minvelle:cart:close'));}
  function showToast(msg){const tt=elRoot.querySelector('.minvelle-cart__toast');if(!tt)return;tt.textContent=msg;tt.setAttribute('visible','');setTimeout(()=>tt.removeAttribute('visible'),4000);}

  async function refresh(){try{state.cart=await fetchCart();render();}catch(e){console.error('[MinvelleCart] refresh failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  function deliveryRange() {
    const start = new Date();
    start.setDate(start.getDate() + 5);
    const end = new Date();
    end.setDate(end.getDate() + 9);
    const opts = { weekday: 'short', month: 'short', day: 'numeric' };
    const lang = (document.documentElement.lang || 'en').slice(0,2);
    const localeTag = lang === 'de' ? 'de-AT' : 'en-US';
    return t('cart.minvelle.delivery_html')
      .replace('{start}', start.toLocaleDateString(localeTag, opts))
      .replace('{end}', end.toLocaleDateString(localeTag, opts));
  }

  function render(){
    const body = elRoot.querySelector('[data-cart-body]');
    const footer = elRoot.querySelector('[data-cart-footer]');
    const stickyCta = elRoot.querySelector('[data-sticky-cta]');
    if (!state.cart) return;
    setCurrency(state.cart.currency);
    updateCartIcon();
    body.innerHTML = '';

    renderShippingBar(state.cart);

    if (!state.cart.items || state.cart.items.length === 0) {
      body.innerHTML = '<div class="minvelle-cart__empty">' +
        '<h3>' + t('cart.minvelle.empty_title') + '</h3>' +
        '<p>' + t('cart.minvelle.empty_body') + '</p>' +
        '<a class="button" href="/pages/minvelle-remineralizing-gum">' + t('cart.minvelle.empty_cta') + '</a>' +
      '</div>';
      footer.hidden = true;
      if (stickyCta) stickyCta.hidden = true;
      return;
    }
    footer.hidden = false;
    if (stickyCta) stickyCta.hidden = false;

    state.cart.items.forEach((item) => body.appendChild(renderLine(item)));

    const promos = elRoot.querySelector('[data-cart-promos]');
    if (promos) {
      promos.innerHTML = '';
      buildPromos(state.cart).forEach((n) => promos.appendChild(n));
    }

    const subtotal = state.cart.items_subtotal_price;
    const sc = shipConsts(state.cart.currency);
    const shipping = sc && subtotal < sc.threshold ? sc.cost : 0;
    const total = subtotal + shipping;

    elRoot.querySelector('[data-checkout-total]').textContent = fmtMoney(total);

    const deliveryEl = elRoot.querySelector('[data-delivery-text]');
    if (deliveryEl) deliveryEl.innerHTML = deliveryRange();
  }

  function renderLine(item){
    const div=document.createElement('div');div.className='minvelle-cart__line';div.dataset.lineKey=item.key;
    const isSub=!!item.selling_plan_allocation;
    const img=item.image||(item.featured_image&&item.featured_image.url)||'';
    const compareCents=item.original_line_price && item.original_line_price>item.final_line_price ? item.original_line_price : null;
    div.innerHTML =
      '<img class="minvelle-cart__line-img" src="'+img+'" alt="'+(item.product_title||'')+'">'+
      '<div class="minvelle-cart__line-meta">'+
        '<span class="minvelle-cart__line-title">'+(item.product_title || '').replace(/Remineralizing\s*/i,'')+'</span>'+
        '<span class="minvelle-cart__line-variant">'+(item.variant_title||'')+'</span>'+
        (isSub?'<span class="minvelle-cart__line-sub-badge"><span style="margin-right:5px">🔁</span>'+t('cart.minvelle.sub_badge')+'</span>':'')+
        '<div class="minvelle-cart__line-qty">'+
          '<button type="button" data-qty-dec aria-label="'+t('cart.minvelle.qty_decrease')+'">−</button>'+
          '<span>'+item.quantity+'</span>'+
          '<button type="button" data-qty-inc aria-label="'+t('cart.minvelle.qty_increase')+'">+</button>'+
        '</div>'+
      '</div>'+
      '<div class="minvelle-cart__line-right">'+
        '<span class="minvelle-cart__line-price">'+fmtMoney(item.final_line_price)+'</span>'+
        (compareCents?'<span class="minvelle-cart__line-compare">'+fmtMoney(compareCents)+'</span>':'')+
        '<button type="button" data-line-remove>'+t('cart.minvelle.remove')+'</button>'+
      '</div>';
    div.querySelector('[data-qty-dec]').addEventListener('click',()=>updateQty(item.key,Math.max(0,item.quantity-1)));
    div.querySelector('[data-qty-inc]').addEventListener('click',()=>updateQty(item.key,item.quantity+1));
    div.querySelector('[data-line-remove]').addEventListener('click',()=>updateQty(item.key,0));
    return div;
  }

  async function updateQty(key,qty){try{state.cart=await changeLine(key,{quantity:qty});render();}catch(e){console.error('[MinvelleCart] updateQty failed',e);showToast(t('cart.minvelle.error_refresh'));}}

  function renderShippingBar(cart){
    const subtotal=cart.items_subtotal_price;
    const bar=elRoot.querySelector('[data-shipping-bar]');
    const fill=elRoot.querySelector('[data-shipping-fill]');
    const label=elRoot.querySelector('[data-shipping-label]');
    const amount=elRoot.querySelector('[data-shipping-amount]');
    const sc=shipConsts(cart.currency);
    if(!sc){bar.hidden=true;return;}
    bar.hidden=false;
    if(subtotal>=sc.threshold){
      bar.classList.add('minvelle-cart__shipping--unlocked');
      label.innerHTML='🎉 <strong>'+t('cart.minvelle.shipping_unlocked')+'</strong>';
      amount.textContent='';
      fill.style.width='100%';
    } else {
      bar.classList.remove('minvelle-cart__shipping--unlocked');
      const remaining = sc.threshold - subtotal;
      label.innerHTML = t('cart.minvelle.shipping_progress_label_html')
        .replace('{current}', fmtMoney(subtotal))
        .replace('{target}', fmtMoney(sc.threshold));
      amount.innerHTML = t('cart.minvelle.shipping_progress_remaining_html').replace('{amount}', fmtMoney(remaining));
      const pct = Math.min(100, Math.max(4, (subtotal / sc.threshold) * 100));
      fill.style.width = pct + '%';
    }
  }

  // Subscription-first upsell hierarchy (2026-07-02). States:
  //   sub line present  -> confirmation chip only, zero competing upsells
  //   2-box one-time    -> HERO subscription switch card (+ secondary 6-pack text link if sole line)
  //   1-box one-time    -> HERO card to 2-box subscription (+ secondary 2-box one-time text link)
  //   6-box / other     -> nothing
  async function swapLine(item, variantId, plan){
    await changeLine(item.key, {quantity: 0});
    await addItem(variantId, 1, plan || null);
    await refresh();
  }
  function promoButton(btn, action){
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      try { await action(); }
      catch (e) { console.error('[MinvelleCart] upsell action', e); btn.disabled = false; showToast(t('cart.minvelle.error_refresh')); }
    });
  }
  function heroCard(title, sub, cta, action){
    const div=document.createElement('div');div.className='minvelle-cart__hero';
    div.innerHTML='<div class="minvelle-cart__hero-title"><span style="margin-right:7px">🔁</span>'+title+'</div>'+
      '<div class="minvelle-cart__hero-sub">'+sub+'</div>'+
      '<button type="button" class="minvelle-cart__hero-cta">'+cta+'</button>';
    promoButton(div.querySelector('button'), action);
    return div;
  }
  function linkCard(label, action){
    const div=document.createElement('div');div.className='minvelle-cart__secondary';
    div.innerHTML='<button type="button" class="minvelle-cart__secondary-link">'+label+'</button>';
    promoButton(div.querySelector('button'), action);
    return div;
  }
  function buildPromos(cart){
    const out=[];
    if(!cart.items || cart.items.length===0) return out;
    if(cart.items.some(it=>!!it.selling_plan_allocation)){
      const chip=document.createElement('div');chip.className='minvelle-cart__sub-chip';
      chip.innerHTML=t('cart.minvelle.sub_locked_chip');
      out.push(chip);
      return out;
    }
    const single = cart.items.length===1 ? cart.items[0] : null;
    const twoBox = cart.items.find(it=>it.variant_id===VARIANT_2BOX);
    if(twoBox){
      out.push(heroCard(t('cart.minvelle.sub_hero_title'), t('cart.minvelle.sub_hero_sub'), t('cart.minvelle.sub_hero_cta'), async ()=>{
        try { state.cart = await changeLine(twoBox.key, {selling_plan: SUB_PLAN_ID}); render(); }
        catch (e) { await swapLine(twoBox, VARIANT_2BOX, SUB_PLAN_ID); } // fallback: remove + re-add with plan
      }));
      if(single) out.push(linkCard(t('cart.minvelle.upsell_2to6_link'), ()=>swapLine(twoBox, VARIANT_6BOX)));
      return out;
    }
    if(single && single.variant_id===VARIANT_1BOX){
      out.push(heroCard(t('cart.minvelle.sub_hero_title'), t('cart.minvelle.sub_hero_1box_sub'), t('cart.minvelle.sub_panel_cta'), ()=>swapLine(single, VARIANT_2BOX, SUB_PLAN_ID)));
      out.push(linkCard(t('cart.minvelle.upsell_add2nd_link'), ()=>swapLine(single, VARIANT_2BOX)));
    }
    return out;
  }

  function bindDiscount(){
    const discountWrap = elRoot.querySelector('[data-discount]');
    const toggle = elRoot.querySelector('[data-discount-toggle]');
    const panel = elRoot.querySelector('[data-discount-panel]');
    const input = elRoot.querySelector('[data-discount-input]');
    const apply = elRoot.querySelector('[data-discount-apply]');
    const msg = elRoot.querySelector('[data-discount-msg]');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const open = !panel.hidden;
      panel.hidden = open;
      if (open) discountWrap.removeAttribute('open');
      else { discountWrap.setAttribute('open',''); input.focus(); }
    });
    apply.addEventListener('click', async () => {
      const code = (input.value || '').trim();
      if (!code) return;
      try {
        await applyDiscount(code);
        msg.textContent = t('cart.minvelle.discount_applied_html').replace('{code}', code);
        msg.classList.remove('minvelle-cart__discount-msg--err');
        msg.classList.add('minvelle-cart__discount-msg--ok');
        msg.hidden = false;
      } catch (e) {
        msg.textContent = t('cart.minvelle.discount_invalid');
        msg.classList.remove('minvelle-cart__discount-msg--ok');
        msg.classList.add('minvelle-cart__discount-msg--err');
        msg.hidden = false;
      }
    });
  }

  function bindAddToCartHooks(){
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (btn) {
        e.preventDefault();
        const vId = parseInt(btn.dataset.variantId, 10);
        const qty = parseInt(btn.dataset.quantity || '1', 10);
        const plan = btn.dataset.sellingPlanId ? parseInt(btn.dataset.sellingPlanId, 10) : null;
        if (!vId) return;
        try { await addItem(vId, qty, plan); await refresh(); open(); }
        catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        return;
      }
      const a = e.target.closest('a[href^="/cart/"]');
      if (a) {
        const m = a.getAttribute('href').match(/^\/cart\/(\d+):(\d+)/);
        if (m) {
          e.preventDefault();
          try { await addItem(parseInt(m[1],10), parseInt(m[2],10)); await refresh(); open(); }
          catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
        }
      }
    });
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const fd = new FormData(form);
      try { const r = await fetch('/cart/add.js', { method: 'POST', body: fd }); if (!r.ok) throw new Error('add-form-failed'); trackATC(await r.json()); await refresh(); open(); }
      catch (err) { console.error(err); showToast(t('cart.minvelle.error_add')); }
    });
  }

  function bindDrawerControls(){
    elRoot.querySelector('.minvelle-cart__close').addEventListener('click', close);
    elBackdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && state.open) close(); });
    document.addEventListener('click', (e) => { const toggle = e.target.closest('[data-cart-toggle]'); if (toggle) { e.preventDefault(); refresh().then(open); } });
  }

  // Header cart icon: no template renders a cart link, so inject one next to the nav CTA (fixed pill as fallback)
  function injectCartIcon(){
    if (document.querySelector('.minvelle-cart-trigger')) return;
    const a=document.createElement('a');
    a.href='/cart';
    a.setAttribute('data-cart-toggle','');
    a.className='minvelle-cart-trigger';
    a.setAttribute('aria-label',(document.documentElement.lang||'').slice(0,2)==='de'?'Warenkorb':'Cart');
    a.innerHTML='<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 4h2l2.4 12.2A2 2 0 0 0 9.36 18h8.34a2 2 0 0 0 1.96-1.6L21.5 8H6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="10" cy="20.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="17.6" cy="20.6" r="1.4" fill="currentColor" stroke="none"/></svg><span class="minvelle-cart-trigger__count" hidden></span>';
    const cta=document.querySelector('.mv-nav .mv-shop-cta, nav .nav-cta, nav .mv-shop-cta');
    if (cta && cta.parentNode) cta.parentNode.insertBefore(a, cta);
    else { a.classList.add('minvelle-cart-trigger--fixed'); document.body.appendChild(a); }
  }
  function updateCartIcon(){
    const b=document.querySelector('.minvelle-cart-trigger__count');
    if(!b)return;
    const n=(state.cart&&state.cart.item_count)||0;
    b.textContent=n>99?'99+':String(n);
    b.hidden=n===0;
  }

  function bindCheckoutOnce(){const btn=elRoot.querySelector('[data-cart-checkout]');if(btn&&!btn._bound){btn._bound=true;btn.addEventListener('click',()=>{window.location.href='/checkout';});}}

  function boot(){
    convertTagged();
    elRoot = document.querySelector('.minvelle-cart');
    elBackdrop = document.querySelector('.minvelle-cart__backdrop');
    if (!elRoot || !elBackdrop) { console.warn('[MinvelleCart] drawer markup not found'); return; }
    bindDrawerControls();
    bindAddToCartHooks();
    bindDiscount();
    injectCartIcon();
    refresh().then(bindCheckoutOnce);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.MinvelleCart = { open, close, refresh, addItem, state, filterWallets };
})();
